/*
  VELUNE reveal system — reveals [data-reveal] elements once, when they enter the viewport.
  Opt-in is done synchronously by snippets/velune-motion.liquid (html.velune-motion); this module only observes.
  Styles: snippets/velune-motion.liquid. No dependencies.
*/
const root = document.documentElement;

function reveal(element) {
  element.classList.add('is-revealed');
  // Drops the stagger delay once the entrance has played, so later hovers react instantly.
  const delayMs = Math.min(parseFloat(getComputedStyle(element).getPropertyValue('--reveal-i')) || 0, 6) * 120;
  window.setTimeout(() => element.classList.add('is-revealed-done'), delayMs + 1000);
}

function start() {
  if (!root.classList.contains('velune-motion')) return;
  root.classList.add('velune-motion-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        reveal(entry.target);
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  const watch = (scope) => {
    scope.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((element) => observer.observe(element));
  };

  watch(document);
  // Sections re-rendered later (theme editor, section rendering API) are picked up too.
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
